import ActionTypes from '../constants/ActionTypes';

export const consentMediaPreviewAllow = (type: number) => ({
  type: ActionTypes.CONSENT_MEDIA_PREVIEW_ALLOW,
  payload: {
    type,
  },
});
